import React from "react";
import { MdOutlineArrowBackIos } from "react-icons/md";
import "./Return.css";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "../Tooltip";

export function Return({ to, showTooltip = true }) {
  const navigate = useNavigate();
  const button = (
    <button onClick={() => navigate(-1)} className="return-button">
      <MdOutlineArrowBackIos />
    </button>
  );

  if (!showTooltip) {
    return button;
  }

  return (
    <Tooltip text="Return">
      {button}
    </Tooltip>
  );
}

